import React, { useState, useEffect } from "react";
import fetchConfig from "../../fetchConfig";
import axios from "axios";

export default function RenderingImage({ style, url, userId }) {
  const [img, setImg] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const token = sessionStorage.getItem("kctoken");

  const fetchImage = async (signal) => {
    try {
      const resp = await fetch(fetchConfig.baseUrl + url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        signal,
      });

      if (!resp.ok) {
        throw new Error("Image not found in fetchImage");
      }

      const imageBlob = await resp.blob();
      return URL.createObjectURL(imageBlob);
    } catch (err) {
      return null;
    }
  };

  const getAvatar = async (account, signal) => {
    try {
      const response = await axios.get(
        fetchConfig.profileUrl + `/photo/img?id=${account}`,
        {
          responseType: "blob",
          signal,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return URL.createObjectURL(response.data);
    } catch (err) {
      return null;
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const loadImage = async () => {
      if (url) {
        const imgFromFetch = await fetchImage(signal);
        if (imgFromFetch) {
          setImg(imgFromFetch);
          return;
        }
      }
      if (userId) {
        const imgFromAvatar = await getAvatar(userId, signal);
        if (imgFromAvatar) {
          setImg(imgFromAvatar);
        } else {
          setNotFound(true);
        }
      }
      return
    };

    loadImage();

    return () => {
      controller.abort();
      if (img) {
        URL.revokeObjectURL(img);
      }
    };
  }, []);

  if (notFound) return <></>;
  if (!img) return null;

  return <img src={img} style={style} />;
}
